import React from 'react';
import {AlbumBrowseCommon} from './AlbumBrowseCommon';
import {PAGE_TITLE_BASE} from './../../constants.js';
import { Header, Segment, Grid, Message } from 'semantic-ui-react'

export function AlbumBrowse(props) {
	document.title = 'Albums | ' + PAGE_TITLE_BASE;

	return (
		<div>
			<Segment inverted>
				<Header inverted as='h1' style={{textAlign:'center'}}>
					Browse Albums
				</Header>
			</Segment>
			<Grid>
				<Grid.Row>
					<Message warning style={{textAlign:'center'}}>
						<Message.Header><br/>This feature is a Beta and is not fully accurate</Message.Header>
					</Message>
				</Grid.Row>
			</Grid>
			<AlbumBrowseCommon urlParams={true}/>
		</div>
	);
}